import { render, staticRenderFns } from "./SearchboxWrapper.vue?vue&type=template&id=71235d3f&scoped=true&"
import script from "./SearchboxWrapper.vue?vue&type=script&lang=ts&"
export * from "./SearchboxWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71235d3f",
  null
  
)

export default component.exports